// extracted by mini-css-extract-plugin
export default {"service":"Ecoworking_service__pc-y-","imagenes":"Ecoworking_imagenes__YNTBV","big":"Ecoworking_big__BdahJ","littles":"Ecoworking_littles__t2ZQd","text":"Ecoworking_text__ppCU4"};